<template>
  <v-app>
    <app-toolbar
      lang-switch
      logo
    />

    <v-main>
      <v-container
        class="fill-height"
        fluid
        ma-0
        pa-0
      >
        <v-row class="fill-height">
          <v-col
            cols="12"
            lg="10"
            offset-lg="1"
          >
            <slot />
          </v-col>
        </v-row>
      </v-container>
    </v-main>

    <app-footer
      :simple="AppInMaintenanceMode"
      class="mt-12"
    />
  </v-app>
</template>

<script>
import SimpleLayoutMixin from '@/theme/default/layouts/SimpleLayout.js'

export default {
  name  : 'SimpleLayout',
  mixins: [SimpleLayoutMixin]
}
</script>

<style scoped src="@/theme/default/layouts/SimpleLayout.css"></style>

<style scoped>

</style>
